import { ClockType } from '@app/entities/enums/mot/clock-type.enum';
import { DayClockingType } from '@app/entities/enums/mot/day-clocking-type.enum';

export { ClockType, DayClockingType };

export class Clocking {
  lastUpdate!: string;
  months!: ClockingMonth[];
}

export class ClockingMonth {
  month!: string;
  days!: ClockingDay[];
}

export class ClockingDay {
  date!: string;
  label!: string;
  clocks!: Clock[];
  hasError!: boolean;
  dayClockingType!: DayClockingType;
  numOfClockings!: number;
  firstEntry!: ClockingDayLimit | null;
  lastExit!: ClockingDayLimit | null;
}

export class ClockingDayLimit {
  time!: string;
  date!: string;
}

export class ClockingRegistry {
  time!: string;
  type!: ClockType;
  date!: string;
}
export class Clock {
  entry!: ClockingRegistry | null;
  exit!: ClockingRegistry | null;
}
